import { isEqual, pickBy, debounce } from 'lodash'
import * as React from 'react'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'
import { Field, FieldArray, Form, Formik, FormikConsumer } from 'formik'
import styled, { createGlobalStyle } from 'styled-components'
import { FormattedMessage, injectIntl, InjectedIntlProps } from 'react-intl'
import { DatePicker } from 'antd'
import * as ReactModal from 'react-modal'
import { Query } from 'react-apollo'
import Spin from 'web-makeup/dist/Spin'
import Select from 'web-makeup/dist/Select'
import Box from 'web-makeup/dist/Box'
import H5 from 'web-makeup/dist/H5'
import Button from 'web-makeup/dist/Button'
import { parse as qp } from 'query-string'
import { Text } from 'web-makeup/dist/design-system/styles/typography'
import { Margin } from 'web-makeup/dist/design-system/styles/spacings'
import Calendar from 'react-calendar'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import * as Yup from 'yup'
import * as moment from 'moment'
import { isAuthenticated } from 'web-fns/dist/auth'
import myStorage from 'web-fns/dist/storage'

import { GET_BRANDS_FOR_PURCHASE } from '../../queries/GetBrandsForPurchase'
import { topLocations } from '../../helpers/top-locations-helper'
import { client as apolloClient } from '../ApolloProvider/ApolloProvider'
import { GetQuoteForm, FindCityV2, AllCountries, QuoteInput } from '../../typings/types'
import OnFormikValueChange from '../OnFormikValueChange/OnFormikValueChange'
import { placeholderColor } from '../../style'
import { BoxHeader } from '../Purchase/Purchase'
import PurchaseShootInspiration from '../PurchaseShootInspiration/PurchaseShootInspiration'
import { UserContext } from '../UserProvider/UserProvider'
import PurchaseProduct from '../PurchaseProduct/PurchaseProduct'
import DefaultButton from '../BrandDashboard/components/DefaultButton/DefaultButton'

import {
  FormFlexWrapper,
  CalendarWrapper,
  MobileCalendarWrapper,
  StyledLabel,
  StyledInput,
  Hr,
  CheckboxWrapper,
  CheckboxInput,
  WhiteBox,
  H1,
  Paragraph,
  DueDateValue,
} from '../PurchaseRedesigned/PurchaseRedesigned.style'
import InfoBlock from '../BrandDashboard/components/ProductPrice/InfoBlock'

const Option = Select.Option

export const AntCalendarStyles = createGlobalStyle`
  .ant-calendar-date.ant-calendar-date.ant-calendar-date {
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.black1};
    background: none;

    &:hover {
      background: ${colors.adaptBlue};
      border-color: ${colors.adaptBlue};
      color: white;
    }
  }
  .ant-calendar-selected-date{
    .ant-calendar-date.ant-calendar-date.ant-calendar-date {
      background: ${colors.adaptBlue};
      border-color: ${colors.adaptBlue};
      color: white;
    }
  }
  .ant-calendar-input-wrap, .ant-calendar-footer {
    display: none;
  }
  .ant-calendar.ant-calendar.ant-calendar {
    background: ${colors.gandalf};
    padding: 0.75rem;
    font-size: 0.75rem;
    line-height: 2;
    border-radius: 0.5rem;
  }
  .ant-calendar-disabled-cell {
    .ant-calendar-date.ant-calendar-date.ant-calendar-date  {
      background: none !importent;
      border: none !importent;
      color: ${colors.dawn};

      &::before {
        border: none;
      }

      &:hover {
        background: none;
        border: none;
        color: ${colors.dawn};
      }
    }
  }

  .ant-calendar-today .ant-calendar-date {
    border: none;
  }
  .ant-select-dropdown-menu-item:hover {
    && {
      background: ${colors.adaptBlue};
      color: white;
    }
  }
  .ant-select-selection__placeholder.ant-select-selection__placeholder {
    color: ${colors.nebula};
  }
`
export const StyledTextArea = styled.textarea`
  border: 1px solid ${colors.radagast};
  font-size: 1rem;
  color: ${colors.black1};
  width: 100%;
  background: white;
  border-radius: 6px;
  padding: 0.69rem;

  &:focus {
    border-color: ${colors.nebula};
    outline: none;
    box-shadow: none;
  }

  &.filled {
    background: ${colors.dust};
    border-color: ${colors.dust};
  }

  ${placeholderColor(colors.nebula)};
`

export const PaddedBox = styled(Box)`
  padding: 1rem;
  margin: 0;
  margin-bottom: 1.5rem;

  @media (min-width: 48rem) {
    max-width: 45rem;
    padding: 2rem;
  }

  @media (min-width: 64rem) {
    max-width: 61rem;
  }

  > ${BoxHeader}:not(:nth-of-type(1)) {
    margin-top: 1.5rem;
  }
`

const StyledForm = styled(Form)`
  display: block;
  margin-bottom: 3rem;
`

const StyledSelect = styled(Select as any)<{ error?: boolean }>`
  &&& {
    width: 100%;
    .ant-select-selection--single {
      border: 1px solid ${({ error }) => (error ? colors.alert : colors.radagast)};
      height: 2.75rem;
      font-size: 1rem;
      color: ${colors.black1};
      width: 100%;

      .ant-select-selection-selected-value {
        line-height: 2.75rem;
      }

      div {
        height: 2.75rem;
      }
    }
    &.ant-select-open {
      .ant-select-selection--single {
        border-color: ${colors.nebula};
        outline: none;
        box-shadow: none;
      }
    }

    &.is-selected {
      .ant-select-selection--single {
        background: ${colors.dust};
        border-color: ${colors.dust};
      }
    }

    &.ant-select-focused .ant-select-selection,
    &.ant-select-focused .ant-select-selection:active,
    &.ant-select-focused .ant-select-selection:focus {
      box-shadow: none;
    }

    ${placeholderColor(colors.nebula)};
  }
`

const ModalButton: any = styled(Button as any)`
  height: auto;
  font-size: 1rem;
`
const ModalContent = styled.div`
  padding: 1rem;

  button {
    display: block;
    margin: 1rem auto 0;
  }
`
const BlockWrapper = styled.div`
  @media (min-width: 64rem) {
    margin-bottom: 2.25rem;
  }

  margin-bottom: 1.5rem;
`
const ModalHeader = styled.div`
  padding: 1rem 1rem 0.5rem;
  border-bottom: 0.063rem #d1d1d1 solid;
`
const FormError = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: ${colors.alert};
  margin-bottom: 0;
  padding-top: 0.25rem;
`
const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    padding: 0,
  },
  overlay: {
    zIndex: 1000,
    backgroundColor: 'rgba(51, 51, 51, 0.5)',
  },
}

const DesktopDDTitle = styled.div`
  display: none;

  @media (min-width: 48rem) {
    display: block;
  }
`

export const GET_COUNTRIES = gql`
  query allCountriesV2 {
    allCountries {
      uuid
      name
    }
  }
`
export const GET_CITIES = gql`
  query FindCityV2($countryUuid: ID, $query: String, $pageSize: Int) {
    findCity(countryUuid: $countryUuid, searchTerm: $query, pageSize: $pageSize) {
      cities {
        uuid
        name
        default
        subdivision1Name
        country {
          uuid
          name
        }
      }
    }
  }
`

export interface OnChangeProps {
  prevValues: QuoteInput
  nextValues: QuoteInput
  keysOfChangedValues: Array<keyof QuoteInput>
}

interface Props {
  onSubmit: (values, actions) => void
  onChange: (props: OnChangeProps) => void
  isFetching: boolean
  initialValues: GetQuoteForm.Variables['quote']
  availableOptions: GetQuoteForm.GetQuoteForm
}

interface FormEffectState {
  values: GetQuoteForm.Variables['quote']
}

export const handleFormEffectChange = (onChange: Props['onChange']) => (
  prevFormikState: FormEffectState,
  nextFormikState: FormEffectState
) => {
  const { values: nextValues } = nextFormikState
  const { values: prevValues } = prevFormikState

  // This is plural/array because I am not certain if React will
  // batch updates causing multiple keys to be changed at once.
  const keysOfChangedValues: Array<keyof GetQuoteForm.Variables['quote']> = Object.keys(
    pickBy(nextValues, (value, key) => !isEqual(prevValues[key], value))
  ) as Array<keyof GetQuoteForm.Variables['quote']>

  // Without this, `onChange` will be triggered twice because Formik always does double-render.
  // https://github.com/jaredpalmer/formik/issues/390
  if (keysOfChangedValues.length === 0) {
    return
  }

  return onChange({ prevValues, nextValues, keysOfChangedValues })
}

export const getCategoryUuid = (searchCategory: string) => {
  if (searchCategory) {
    const { data } = useQuery(GET_CITIES, {
      variables: { query: searchCategory },
      client: apolloClient,
    })
    if (data && data.findCity && data.findCity.cities && data.findCity.cities.length > 0) {
      const defaultCity = data.findCity.cities.find(city => city.default)
      const firstCity = data.findCity.cities[0]
      if (firstCity) {
        return { dCountry: firstCity.country, dCity: firstCity }
      }
      if (defaultCity) {
        return { dCountry: defaultCity.country, dCity: defaultCity }
      }
    }
  }
  return { dCountry: [], dCity: [] }
}

export const PurchaseOrder: React.FunctionComponent<Props & InjectedIntlProps> = ({
  isFetching,
  initialValues,
  onSubmit,
  onChange,
  intl,
}) => {
  const searchCategory =
    'category' in qp(window.location.search)
      ? qp(window.location.search).category.replace(/-/g, ' ')
      : ''
  const { dCountry, dCity } = getCategoryUuid(searchCategory)
  const [countryUuid, setCountryUuid] = React.useState<string>(dCountry.uuid)
  const [cityUuid, setCityUuid] = React.useState<string | []>(dCity.uuid)
  const [cityQuery, setCityQuery] = React.useState<string>()
  const setCityQueryDebounced = React.useCallback(debounce(setCityQuery, 500), [])
  const [checked, setChecked] = React.useState(false)
  const [showModal, setShowModal] = React.useState(false)
  const [isCoutrySelected, setIsCoutrySelected] = React.useState(false)
  const [isCitySelected, setIsCitySelected] = React.useState(false)
  const [isDatePickerFilled, setIsDatePickerFilled] = React.useState(false)
  const [isErrorVisible, setIsErrorVisible] = React.useState(false)
  const [validFields, setValidFields] = React.useState({
    title: false,
    location: false,
    dueDate: false,
    budget: false,
    terms: false,
  })

  const validateFields = Object.values(validFields as any).every(el => el === false)

  const handleCloseModal = () => setShowModal(false)

  // @ts-ignore
  const formatter = new Intl.DateTimeFormat('en-GB', { dateStyle: 'full' })

  const preventMinus = e => {
    if ([69, 187, 107, 189, 109].includes(e.keyCode)) {
      e.preventDefault()
    }
  }

  const DropDownArrow =
    countryUuid && !dCountry.uuid ? (
      <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
    ) : (
      <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632413441/-design-system/icon-arrow-down-passive.svg" />
    )

  const disabledDate = current => {
    // Can not select days before today and today
    return current && current < moment().add(-1, 'days')
  }

  const fullCityName = (cityName, stateName): string => {
    const names: string[] = [cityName]
    if (stateName !== cityName && stateName !== null) {
      names.push(stateName)
    }
    return names.join(', ')
  }

  React.useEffect(
    () => {
      if (dCountry.uuid) {
        setIsCoutrySelected(true)
      }
      if (dCity.uuid) {
        setIsCitySelected(true)
      }
    },
    [dCountry.uuid, dCity.uuid]
  )

  const initialLocation = {
    cityUuid: dCity.uuid,
    countryUuid: dCountry.uuid,
  }

  const { brandUuid } = React.useContext(UserContext)
  const { data: brandProfileData } = useQuery(GET_BRANDS_FOR_PURCHASE, {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    client: apolloClient,
  })
  const { allBrandsForPurchase } = brandProfileData || ''
  const currentBrand =
    allBrandsForPurchase && allBrandsForPurchase.filter(obj => obj.uuid === brandUuid)
  const currentBrandCurrencySymbol =
    currentBrand &&
    currentBrand[0] &&
    currentBrand[0].country &&
    currentBrand[0].country.currencySymbol
  const currentBrandCurrencyCode =
    currentBrand &&
    currentBrand[0] &&
    currentBrand[0].country &&
    currentBrand[0].country.currencyCode

  const currencyCode = isAuthenticated() ? currentBrandCurrencyCode : 'USD'
  const currencySymbol = isAuthenticated() ? currentBrandCurrencySymbol : '$'
  const PURCHASE_CUSTOM_TITLE = 'PURCHASE_CUSTOM_TITLE'

  return (
    <>
      <AntCalendarStyles />
      <Formik<QuoteInput>
        // To allow for one-way data flow, the response from BE (or really just `props`)
        // must always be the single source of truth when data is not in sync.
        enableReinitialize
        initialValues={{
          ...initialValues,
          ...initialLocation,
          custom: true,
          budget: 0,
          title: '',
        }}
        validationSchema={Yup.object().shape({
          title: Yup.string().required('Title is required'),
          countryUuid: Yup.string().required('Select a country'),
          cityUuid: Yup.string().required('Select a city'),
          projectDueAt: Yup.string().required('Type in a due date'),
          budget: Yup.number().required('Type in budget'),
        })}
        onSubmit={() => {
          return
        }}
      >
        {({ values, isSubmitting }) => {
          const showTitleError = values.title === '' && isErrorVisible
          const showBudgetError = !values.budget && isErrorVisible
          const showDateError = !values.projectDueAt && isErrorVisible
          const showCheckedError = !checked && isErrorVisible
          const showLocationError = !isCitySelected && isErrorVisible

          React.useEffect(
            () => {
              setValidFields({
                title: showTitleError,
                location: showLocationError,
                dueDate: showDateError,
                budget: showBudgetError,
                terms: showCheckedError,
              })
            },
            [
              isErrorVisible,
              showTitleError,
              showLocationError,
              showDateError,
              showBudgetError,
              showCheckedError,
            ]
          )
          return (
            <StyledForm>
              <FormikConsumer>
                {formik => (
                  <OnFormikValueChange
                    formik={formik}
                    onChange={handleFormEffectChange(onChange)}
                  />
                )}
              </FormikConsumer>
              <H1>Submit a video brief</H1>
              <Paragraph>
                Complete the following fields to get a more accurate quote. Our Service Team will
                reach out to you shortly with a customised quote.
              </Paragraph>
              <PurchaseProduct />
              {isErrorVisible &&
                !validateFields && (
                  <BlockWrapper>
                    <InfoBlock validFields={validFields} />
                  </BlockWrapper>
                )}
              <WhiteBox>
                <FormFlexWrapper>
                  <div>
                    <Text as="div" fontSize="h5" fontWeight="bold" color="black1">
                      Project name
                    </Text>
                    <Margin bottom size="xSmall" />
                    <Field name="title">
                      {({ field }) => (
                        <FormikConsumer>
                          {formik => {
                            return (
                              <StyledInput
                                error={showTitleError}
                                placeholder={intl.formatMessage({
                                  id: 'purchase.project.placeholder',
                                })}
                                onChange={val => {
                                  myStorage.setItem(PURCHASE_CUSTOM_TITLE, 'true')
                                  formik.setFieldValue(field.name, val.target.value)
                                  formik.setFieldTouched(field.name, true)
                                }}
                                onBlur={val =>
                                  val.target.value
                                    ? val.target.classList.add('is-filled')
                                    : val.target.classList.remove('is-filled')
                                }
                              />
                            )
                          }}
                        </FormikConsumer>
                      )}
                    </Field>
                    {showTitleError && <FormError>Project name is required.</FormError>}
                    <Margin bottom size="medium" />
                    <Text as="div" fontSize="h5" fontWeight="bold" color="black1">
                      Location
                    </Text>
                    <Margin bottom size="xSmall" />
                    <Field name="countryUuid" data-testid="purchase_country">
                      {({ field: { name }, form }) => (
                        <Query<AllCountries.Query, AllCountries.Variables>
                          query={GET_COUNTRIES}
                          errorPolicy="all"
                        >
                          {({ loading, data: queryData }) => {
                            if (loading || (searchCategory && dCountry.uuid === undefined)) {
                              return <Spin size="small" />
                            }
                            const data = (queryData && queryData.allCountries) || []
                            const blackListedCountry = [
                              'Iran',
                              'Cuba',
                              'North Korea',
                              'Venezuela',
                              'Ukraine',
                              'Syria',
                            ]
                            const topListedCountry = [
                              'New Zealand',
                              'Australia',
                              'United Kingdom',
                              'Singapore',
                              'United States',
                              'Japan',
                              'Hong Kong',
                              'China',
                              'Germany',
                              'India',
                            ]
                            const filteredData = data.filter(obj => {
                              return !blackListedCountry.some(v => obj.name === v)
                            })
                            topListedCountry
                              .slice(0)
                              .reverse()
                              .map(item => topLocations(item, filteredData))

                            return (
                              <>
                                <StyledSelect
                                  className={isCoutrySelected ? `is-selected` : ``}
                                  error={!isCoutrySelected && isErrorVisible}
                                  data-testid="purchase_country_select"
                                  showSearch
                                  placeholder="Select a country"
                                  defaultValue={dCountry.uuid}
                                  suffixIcon={
                                    <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                                  }
                                  onSelect={val =>
                                    val !== undefined
                                      ? setIsCoutrySelected(true)
                                      : setIsCoutrySelected(false)
                                  }
                                  onChange={value => {
                                    setCountryUuid(value)
                                    setCityUuid([])
                                    form.setFieldValue(name, value)
                                  }}
                                  filterOption={(input, option) =>
                                    option.props.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                                  {filteredData.map(country => (
                                    <Option key={country.uuid} value={country.uuid}>
                                      {country.name}
                                    </Option>
                                  ))}
                                </StyledSelect>
                                <Margin bottom size="xSmall" />
                              </>
                            )
                          }}
                        </Query>
                      )}
                    </Field>
                    <Field name="cityUuid" data-testid="purchase_city">
                      {({ field: { name }, form }) => (
                        <Query<FindCityV2.Query, FindCityV2.Variables>
                          query={GET_CITIES}
                          variables={{ countryUuid, query: cityQuery, pageSize: 30 }}
                          errorPolicy="all"
                        >
                          {({ data: queryData, loading }) => {
                            const data =
                              (queryData && queryData.findCity && queryData.findCity.cities) || []

                            if (!cityUuid && !data.find(city => city.uuid === dCity.uuid)) {
                              data.push({
                                name: dCity.name,
                                uuid: dCity.uuid,
                                default: true,
                                subdivision1Name: dCity.subdivision1Name,
                                country: {
                                  name: '',
                                  uuid: countryUuid,
                                },
                              })
                            }
                            const choosenCity = e => {
                              const filteredCity = data.find(
                                item => fullCityName(item.name, item.subdivision1Name) === e
                              )
                              if (filteredCity) {
                                return filteredCity.uuid
                              }
                              return ''
                            }
                            const choosenUrlCity = e => {
                              const filteredCity = data.find(item => item.uuid === e)
                              if (filteredCity) {
                                return fullCityName(
                                  filteredCity.name,
                                  filteredCity.subdivision1Name
                                )
                              }
                              return ''
                            }

                            return (
                              <>
                                <StyledSelect
                                  className={isCitySelected ? `is-selected` : ``}
                                  error={!isCitySelected && isErrorVisible}
                                  onSelect={val =>
                                    val !== undefined
                                      ? setIsCitySelected(true)
                                      : setIsCitySelected(false)
                                  }
                                  mode="combobox"
                                  data-testid="purchase_city_select"
                                  suffixIcon={DropDownArrow}
                                  notFoundContent={
                                    loading ? (
                                      <Spin size="small" />
                                    ) : (
                                      <FormattedMessage id="purchase.shoot.location.not_found" />
                                    )
                                  }
                                  showSearch
                                  value={cityUuid ? cityUuid : choosenUrlCity(dCity.uuid)}
                                  disabled={!countryUuid && !dCountry.uuid ? true : false}
                                  onSearch={setCityQueryDebounced}
                                  onChange={value => {
                                    setCityUuid(value)
                                    form.setFieldValue(name, choosenCity(value))
                                  }}
                                  placeholder="Select a city"
                                  filterOption={(input, option) =>
                                    option.props.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {data.map(city => (
                                    <Option
                                      key={city.uuid}
                                      value={fullCityName(city.name, city.subdivision1Name) || ''}
                                    >
                                      {fullCityName(city.name, city.subdivision1Name)}
                                    </Option>
                                  ))}
                                </StyledSelect>
                                {showLocationError && <FormError>Location is required.</FormError>}
                              </>
                            )
                          }}
                        </Query>
                      )}
                    </Field>
                    <Margin bottom size="medium" />
                    <Text as="div" fontSize="h5" fontWeight="bold" color="black1">
                      Budget
                    </Text>
                    <Margin bottom size="xSmall" />
                    <StyledLabel>
                      <Text as="div" fontSize="h5" style={{ minWidth: '46px' }}>
                        {currencyCode}{' '}
                        <Text as="span" fontSize="h4" fontWeight="black">
                          {currencySymbol}
                        </Text>
                      </Text>
                      <Margin right size="xSmall" />
                      <Field name="budget" data-testid="purchase_budget">
                        {({ field: { name }, form }) => {
                          return (
                            <StyledInput
                              error={showBudgetError}
                              onBlur={val =>
                                val.target.value
                                  ? val.target.classList.add('is-filled')
                                  : val.target.classList.remove('is-filled')
                              }
                              type="number"
                              placeholder="How much you're looking to spend"
                              onKeyDown={e => preventMinus(e)}
                              onChange={e => {
                                form.setFieldValue(name, Number(e.target.value))
                              }}
                            />
                          )
                        }}
                      </Field>
                    </StyledLabel>
                    {showBudgetError && <FormError>Budget is required.</FormError>}
                    <Margin bottom size="medium" />
                    <MobileCalendarWrapper>
                      <Text as="div" fontSize="h5" fontWeight="bold" color="black1">
                        Due date
                      </Text>
                      <Margin bottom size="xSmall" />
                      <Field name="projectDueAt">
                        {({ field: { name }, form }) => {
                          return (
                            <DatePicker
                              className={isDatePickerFilled ? 'filled' : ''}
                              suffixIcon={
                                <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                              }
                              onChange={value => {
                                form.setFieldValue(name, value)
                                value !== null
                                  ? setIsDatePickerFilled(true)
                                  : setIsDatePickerFilled(false)
                              }}
                              format={'D MMMM YYYY, dddd'}
                              disabledDate={disabledDate}
                            />
                          )
                        }}
                      </Field>
                    </MobileCalendarWrapper>
                    <Text as="div" fontSize="h5" fontWeight="bold" color="black1">
                      Video creation brief
                    </Text>
                    <Margin bottom size="xSmall" />
                    <Field name="description">
                      {({ field: { name }, form }) => (
                        <StyledTextArea
                          onChange={e => form.setFieldValue(name, e.target.value)}
                          onBlur={val =>
                            val.target.value
                              ? val.target.classList.add('filled')
                              : val.target.classList.remove('filled')
                          }
                          data-testid="purchase_description"
                          rows={6}
                          placeholder="Provide as much information as possible"
                        />
                      )}
                    </Field>
                    <Margin bottom size="medium" />
                    <Text as="div" fontSize="h2" fontWeight="black" color="black1">
                      Inspiration
                    </Text>
                    <Margin bottom size="xxSmall" />
                    <Text as="div" fontSize="h4" color="black1">
                      Add URLs of content you are inspired by
                    </Text>
                    <Margin bottom size="xxSmall" />
                    <Text as="div" fontSize="h5" fontWeight="bold" color="black1">
                      Inspiration content URL
                    </Text>
                    <Margin bottom size="xSmall" />
                    <FieldArray name="inspirationVideoUrls">
                      {({ push, remove }) => (
                        <>
                          <PurchaseShootInspiration
                            data-testid="purchase_description"
                            loading={isFetching}
                            onAdd={push}
                            onRemove={remove}
                            values={values.inspirationVideoUrls}
                            color={colors.saruman}
                          />
                        </>
                      )}
                    </FieldArray>
                    <Hr />

                    <CheckboxWrapper>
                      <CheckboxInput
                        showCheckedError={showCheckedError}
                        data-testid="toc-checkbox"
                        type="checkbox"
                        defaultChecked={checked}
                        onChange={() => {
                          checked ? setChecked(false) : setChecked(true)
                        }}
                        id="tocCheckbox"
                      />
                      <label htmlFor="tocCheckbox">
                        {`I have read and agree to `}
                        <a href="https://90seconds.com/brand-terms/">Terms & Conditions</a>
                        {` and `}
                        <a href="https://90seconds.com/privacy/">Privacy Policy</a>.
                      </label>
                    </CheckboxWrapper>
                    {showCheckedError && (
                      <FormError>Please accept Terms & Conditions and Privacy Policy.</FormError>
                    )}
                  </div>
                  <div>
                    <DesktopDDTitle>
                      <Text as="div" fontSize="h5" fontWeight="bold" color="black1">
                        Due date
                      </Text>
                    </DesktopDDTitle>
                    <Margin bottom size="xSmall" />
                    <CalendarWrapper showDateError={showDateError}>
                      <Field name="projectDueAt">
                        {({ field: { name }, form }) => {
                          return (
                            <Calendar
                              onChange={value => {
                                form.setFieldValue(name, value)
                              }}
                              minDate={new Date()}
                            />
                          )
                        }}
                      </Field>
                    </CalendarWrapper>
                    {showDateError && <FormError>Due date is required.</FormError>}
                    <DueDateValue as="div" fontSize="h5" fontWeight="bold" color="black1">
                      {values.projectDueAt && formatter.format(values.projectDueAt)}
                    </DueDateValue>
                  </div>
                </FormFlexWrapper>
                <Margin bottom size="medium" />
                <FormikConsumer>
                  {formik => {
                    return (
                      <DefaultButton
                        onClick={e => {
                          if (formik.dirty && formik.isValid && values.budget && checked) {
                            onSubmit(values, e)
                          } else {
                            setIsErrorVisible(true)
                            window.scrollTo({
                              top: 0,
                              behavior: 'smooth',
                            })
                          }
                        }}
                        data-testid="submit-button"
                        rounded
                        backgroundColor={colors.adaptBlue}
                        color={colors.white}
                        fullWidth
                        buttonHeight="3.75rem"
                        hoverBackground={colors.adaptBlue}
                      >
                        Submit your brief
                      </DefaultButton>
                    )
                  }}
                </FormikConsumer>
              </WhiteBox>
            </StyledForm>
          )
        }}
      </Formik>

      <ReactModal
        isOpen={showModal}
        style={modalStyles}
        onRequestClose={handleCloseModal}
        data-testid="purchase_modal"
      >
        <ModalHeader>
          <H5>
            <FormattedMessage id="react.modal.title" />
          </H5>
        </ModalHeader>
        <ModalContent>
          <FormattedMessage id="react.modal.message" />
          <ModalButton onClick={() => handleCloseModal()} type="primary">
            <FormattedMessage id="react.modal.button" />
          </ModalButton>
        </ModalContent>
      </ReactModal>
    </>
  )
}

export default injectIntl(PurchaseOrder)



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderRedesigned/PurchaseOrderRedesigned.tsx